import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

Vue.use(VueRouter);

const routes = [
  { path: '/', name: 'Home', component: () => import('../views/Home.vue'), meta: { requiresAuth: true } },
  { path: '/login', name: 'Login', component: () => import('../views/Login.vue') },
  { path: '/register', name: 'Register', component: () => import('../views/Register.vue') },
  { path: '/forgot-password', name: 'ForgotPassword', component: () => import('../views/ForgotPassword.vue') },
  { path: '/chat/:subjectId', name: 'Chat', component: () => import('../views/Chat.vue'), meta: { requiresAuth: true } },
  { path: '/history', name: 'History', component: () => import('../views/History.vue'), meta: { requiresAuth: true } },
  { path: '/profile', name: 'Profile', component: () => import('../views/Profile.vue'), meta: { requiresAuth: true } },
  { path: '/weak-points', name: 'WeakPoints', component: () => import('../views/WeakPoints.vue'), meta: { requiresAuth: true } },
  { path: '/quiz/:subjectId', name: 'Quiz', component: () => import('../views/Quiz.vue'), meta: { requiresAuth: true } },
  { path: '/courses/:subjectId', name: 'CourseList', component: () => import('../views/CourseList.vue'), meta: { requiresAuth: true } },
  { path: '/course/:courseId', name: 'CourseLearn', component: () => import('../views/CourseLearn.vue'), meta: { requiresAuth: true } },
  { path: '/course/:courseId/learn', name: 'CoursePlayer', component: () => import('../views/CoursePlayer.vue'), meta: { requiresAuth: true } },
  { path: '/course-generate', name: 'CourseGenerate', component: () => import('../views/CourseGenerate.vue'), meta: { requiresAuth: true } },
  { path: '/admin/courses', name: 'AdminCourseManage', component: () => import('../views/admin/CourseManage.vue'), meta: { requiresAuth: true } },
  // 家长端独立登录和页面
  { path: '/parent-login', name: 'ParentLogin', component: () => import('../views/parent/ParentLogin.vue') },
  { path: '/parent', name: 'ParentHome', component: () => import('../views/parent/ParentHome.vue'), meta: { requiresAuth: true, isParent: true } },
  { path: '/parent/report', name: 'ParentReport', component: () => import('../views/parent/Report.vue'), meta: { requiresAuth: true, isParent: true } },
  { path: '/parent/quiz-generator', name: 'QuizGenerator', component: () => import('../views/parent/QuizGenerator.vue'), meta: { requiresAuth: true, isParent: true } },
  { path: '/parent/teaching-plan', name: 'TeachingPlan', component: () => import('../views/parent/TeachingPlan.vue'), meta: { requiresAuth: true, isParent: true } }
];

const router = new VueRouter({
  mode: 'hash',
  routes
});

router.beforeEach((to, from, next) => {
  const token = store.state.token || localStorage.getItem('smartstudy_token');
  const role = store.state.role || localStorage.getItem('smartstudy_role') || 'student';

  if (token && !store.state.token) {
    store.commit('SET_TOKEN', token);
  }

  // 家长端页面需要家长身份
  if (to.meta.isParent) {
    if (!token) {
      next('/parent-login');
      return;
    }
    // 已登录但不是家长身份，强制退出到家长登录页
    if (role !== 'parent') {
      store.commit('CLEAR_AUTH');
      next('/parent-login');
      return;
    }
    next();
    return;
  }

  // 学生端页面
  if (to.meta.requiresAuth && !token) {
    next('/login');
    return;
  }

  // 家长登录页，已登录且是家长身份则跳转家长首页
  if (to.path === '/parent-login' && token && role === 'parent') {
    next('/parent');
    return;
  }

  // 学生登录页，已登录且是学生身份则跳转学生首页
  if ((to.path === '/login' || to.path === '/register') && token && role === 'student') {
    next('/');
    return;
  }

  // 已登录家长访问学生页面，提示并留在当前页
  if (to.meta.requiresAuth && !to.meta.isParent && token && role === 'parent') {
    next('/parent');
    return;
  }

  next();
});

export default router;